import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { Loading } from 'src/components/shared/Loading';
import { LoadingFailed } from 'src/components/shared/LoadingFailed';
import { PageLayout } from '../shared/PageLayout';

const LifeSupportsLoadingFailed: React.FC = () => {
  const { t } = useTranslation(['life_supports', 'translation']);
  return (
    <PageLayout
      title={t('top')}
      color="#c4bced"
      backLabel={t('translation:aria_button_back_to_previous')}
      background="#d7d2f3"
    >
      <LoadingFailed error="unstable-network" />
    </PageLayout>
  );
};

const LifeSupportsLoading: React.FC = () => {
  const { t } = useTranslation(['life_supports', 'translation']);
  return (
    <PageLayout
      title={t('top')}
      color="#c4bced"
      backLabel={t('translation:aria_button_back_to_previous')}
      background="#d7d2f3"
    >
      <Loading />
    </PageLayout>
  );
};

const LifeSupports = React.lazy(() => import('./LifeSupports'));

export default class extends React.Component<Record<string, unknown>, { hasError?: boolean }> {
  constructor(props: Record<string, unknown>) {
    super(props);
    this.state = { hasError: false };
  }
  public static getDerivedStateFromError(_error: Error) {
    return { hasError: true };
  }
  public render() {
    if (this.state.hasError) {
      return <LifeSupportsLoadingFailed />;
    } else {
      return (
        <Suspense fallback={<LifeSupportsLoading />}>
          <LifeSupports />
        </Suspense>
      );
    }
  }
}
